jQuery.noConflict();
( function( $ ) {
	$( '.slider-block' ).slick( {
		dots: true,
		arrows: false,
		autoplay: true,
		fade: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		customPaging() {
			return '<button class="sliderbutton clickonhover" type="button" role="tab"><div class="slidericon"></div></button>';
		},
	} );
	$( '.slider-block-aging' ).slick( {
		dots: true,
		arrows: false,
		autoplay: true,
		fade: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		customPaging() {
			return '<button class="sliderbutton clickonhover" type="button" role="tab"><div class="slidericon-aging"></div></button>';
		},
	} );
	$( '.slider-block-stability' ).slick( {
		dots: true,
		arrows: false,
		autoplay: true,
		fade: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		customPaging() {
			return '<button class="sliderbutton clickonhover" type="button" role="tab"><div class="slidericon-stability"></div></button>';
		},
	} );
	$( '.slider-block-purpose' ).slick( {
		dots: true,
		arrows: false,
		autoplay: true,
		fade: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		customPaging() {
			return '<button class="sliderbutton clickonhover" type="button" role="tab"><div class="slidericon-purpose"></div></button>';
		},
	} );
	$( '.slider-block-education' ).slick( {
		dots: true,
		arrows: false,
		autoplay: true,
		fade: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		customPaging() {
			return '<button class="sliderbutton clickonhover" type="button" role="tab"><div class="slidericon-education"></div></button>';
		},
	} );
}( jQuery ) );

